import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { mockShalaAdminMenu, mockShalaSubAdminMenu } from '../data/menu.data';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menu: Subject<any[]> = new Subject<any[]>();

  // Child keys that belong to the 'masters' parent folder
  childKeyArray = [
    'banners',
    'editorials',
    'subjects',
    'chapters',
    'topics',
    'exam',
    'exam-category',
    'success-stories',
    'current-affairs',
    'resource',
    'testimonial',
  ];

  // Child keys that belong to the 'User' parent folder
  userChildKeyArray = [
    'User',
    'job-alerts',
    'job-applications',
    'push-notifications',
    'announcement',
    'support-details',
  ];

  constructor(private localStorageService: LocalStorageService) {}

  public generateMenu(userRole: string): void {
    let keysToInclude = this.localStorageService.getItem('user').allowedRoute;

    let mastersAdded = false;
    let userAdded = false;

    keysToInclude = keysToInclude.reduce((acc: any, item: any) => {
      // Auto-inject 'masters' parent if any master child key is found
      if (this.childKeyArray.includes(item)) {
        if (!mastersAdded) {
          acc.push('masters');
          mastersAdded = true;
        }
      }

      // Auto-inject 'User' parent if any user child key is found
      if (this.userChildKeyArray.includes(item)) {
        if (!userAdded) {
          acc.push('User');
          userAdded = true;
        }
      }

      acc.push(item);
      return acc;
    }, []);
    const filteredMenu = mockShalaSubAdminMenu
      .filter((item) => keysToInclude.includes(item.key))
      .map((menuItem) => {
        return {
          ...menuItem,
          children: menuItem.children.filter((childItem) =>
            keysToInclude.includes(childItem.key),
          ),
        };
      });

    if (userRole === 'subAdmin') {
      this.menu.next(filteredMenu);
    } else {
      this.menu.next(mockShalaAdminMenu);
    }
  }
}
